import {
  useCurrentActivities,
  useCurrentActivity,
  useCurrentEventKind,
  useActivityWorkflowActions,
  useCurrentAsset,
  useLinkedSiteDefaults,
} from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import ActivityAttributeEditorForStatus from "../ActivityAttributeEditorForStatus"
import { ActivityEditProps, ActivityManageScreen } from "./screens"
import { getAttributeValuesForEventKind } from "./attributes"
import ActivityScreenWrapper from "./ActivityScreenWrapper"
import { useLatestBatch } from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import ActivityLoading from "./ActivityLoading"
import { useMemo } from "react"

interface ActivityEditAttributeProps extends ActivityEditProps {}

const ActivityEditAttribute = ({ onScreenChange, onBack, onChange }: ActivityEditAttributeProps) => {
  const activity = useCurrentActivity()
  const activities = useCurrentActivities()
  const asset = useCurrentAsset()
  const eventKind = useCurrentEventKind()
  const { needToRefresh, setLinkedSiteDefaults } = useActivityWorkflowActions()
  const latestBatch = useLatestBatch()
  const linkedSiteDefaults = useLinkedSiteDefaults()
  if (!activity || !activities || !eventKind) {
    return <ActivityLoading />
  }

  // Merge linked site defaults into existing values for the current status
  const existingValues = useMemo(() => {
    const values = getAttributeValuesForEventKind(activity, eventKind)
    if (linkedSiteDefaults) {
      // "" = explicitly clear (won't be overridden by defaults), string = set to this value, undefined = no change
      if (linkedSiteDefaults.source !== undefined) {
        values.source = linkedSiteDefaults.source ?? ""
      }
      if (linkedSiteDefaults.destination !== undefined) {
        values.destination = linkedSiteDefaults.destination ?? ""
      }
    }
    return values
  }, [activity, eventKind, linkedSiteDefaults])

  return (
    <ActivityScreenWrapper>
      <ActivityAttributeEditorForStatus
        asset={asset}
        order={undefined}
        activity={activity}
        activities={activities}
        eventKind={eventKind}
        existingValues={existingValues}
        isStatusProgression={false}
        onSuccess={() => {
          // Clear linked site defaults after successful save
          setLinkedSiteDefaults({ source: undefined, destination: undefined })
          needToRefresh()
          onChange()
        }}
        onCancel={onBack}
        onBack={onBack}
        onNavigateToBatchCreation={() => onScreenChange(ActivityManageScreen.CreateBatch)}
        newlyCreatedBatch={latestBatch}
      />
    </ActivityScreenWrapper>
  )
}

export default ActivityEditAttribute
